'use client';

import { useSyncExternalStore } from 'react';

const suscribir = () => () => {};

/**
 * `false` en el servidor y en el primer render, `true` una vez montado.
 *
 * Sirve para lo que sólo existe en el navegador —`document.body` de un portal,
 * por ejemplo—. Va por `useSyncExternalStore` y no por `useState` + `useEffect`
 * porque el repo trata `react-hooks/set-state-in-effect` como ERROR, y además
 * así no hay un render extra.
 */
export function useIsMounted() {
	return useSyncExternalStore(suscribir, () => true, () => false);
}
